export class Dates {

  dateAdd(original: any, increment: any, unit: any): Date {

    if (!(original instanceof Date)) {
      return (undefined);
    }

    switch (unit) {
      case 'days':
        // Add number of days to current date
        var newDate = new Date(original);
        newDate.setDate(original.getDate() + increment);
        return newDate;
      case 'weeks':
        // Add number of weeks to current date
        var newDate = new Date(original);
        newDate.setDate(original.getDate() + (increment * 7));
        return newDate;
      case 'months':
        // Get current date
        var oldDate = original.getDate();

        // Increment months (handles year rollover)
        var newDate = new Date(original);
        newDate.setMonth(original.getMonth() + increment);

        // If new day and old day aren't equal, set new day to last day of last month
        // (handles edge case when adding month to Jan 31st for example. Now goes to Feb 28th)
        if (newDate.getDate() != oldDate) {
          newDate.setDate(0);
        }

        // Handle leap years
        // If old date was Feb 29 (leap year) and new year isn't leap year, set new date to Feb 28
        if (newDate.getDate() == 29 && newDate.getMonth() == 1 && !this.isLeapYear(newDate.getFullYear())) {//FB50240-Pawan Prajapati
          newDate.setMonth(1);
          newDate.setDate(28);
        }

        return newDate;
      case 'years':
        // Increment years
        var newDate = new Date(original);
        newDate.setFullYear(original.getFullYear() + increment);

        // Handle leap years
        // If old date was Feb 29 (leap year) and new year isn't leap year, set new date to Feb 28
        if (newDate.getDate() == 29 && newDate.getMonth() == 1 && !this.isLeapYear(newDate.getFullYear())) {//FB50240-Pawan Prajapati
          newDate.setMonth(1);
          newDate.setDate(28);
        }

        return newDate;
      // Defaults to milliseconds
      default:
        var newDate = new Date(original);
        newDate.setTime(original.getTime() + increment);
        return newDate;
    }
  };

  private isLeapYear(year: any) {
    return (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0));
  }
}
